"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.getSpinnerDimension = exports.SpinnerSize = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));

var _react = _interopRequireDefault(require("react"));

var _core = require("@emotion/core");

var _stencilReactDesc = require("@amzn/stencil-react-desc");

var _utils = require("../utils");

var _text = require("../text");

var _layout = require("../layout");

var _liveAnnouncer = require("../live-announcer");

var _ProgressArc = require("./ProgressArc");

var _utils2 = require("./utils");

var rotate = (0, _core.keyframes)({
  from: {
    transform: 'rotate(0deg)'
  },
  to: {
    transform: 'rotate(360deg)'
  }
});
var SpinnerSize;
exports.SpinnerSize = SpinnerSize;

(function (SpinnerSize) {
  SpinnerSize["Small"] = "s";
  SpinnerSize["Medium"] = "m";
  SpinnerSize["Large"] = "l";
})(SpinnerSize || (exports.SpinnerSize = SpinnerSize = {}));

var getSpinnerDimension = function getSpinnerDimension(size) {
  switch (size) {
    case SpinnerSize.Small:
      return 28;

    case SpinnerSize.Medium:
      return 70;

    case SpinnerSize.Large:
      return 104;

    default:
      return size;
  }
};

exports.getSpinnerDimension = getSpinnerDimension;

var SpinnerComponent = function SpinnerComponent(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? SpinnerSize.Small : _ref$size,
      _ref$start = _ref.start,
      start = _ref$start === void 0 ? 0 : _ref$start,
      _ref$progress = _ref.progress,
      progress = _ref$progress === void 0 ? 0.66666 : _ref$progress,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'primary70' : _ref$color,
      _ref$opacity = _ref.opacity,
      opacity = _ref$opacity === void 0 ? 0.5 : _ref$opacity,
      _ref$strokeWidth = _ref.strokeWidth,
      strokeWidth = _ref$strokeWidth === void 0 ? 4 : _ref$strokeWidth,
      _ref$margin = _ref.margin,
      margin = _ref$margin === void 0 ? 0 : _ref$margin,
      _ref$loadingText = _ref.loadingText,
      loadingText = _ref$loadingText === void 0 ? 'Loading...' : _ref$loadingText,
      _ref$showText = _ref.showText,
      showText = _ref$showText === void 0 ? false : _ref$showText,
      _ref$textColor = _ref.textColor,
      textColor = _ref$textColor === void 0 ? 'neutral70' : _ref$textColor,
      outerProps = (0, _objectWithoutProperties2.default)(_ref, ["size", "start", "progress", "color", "opacity", "strokeWidth", "margin", "loadingText", "showText", "textColor"]);
  var isSmall = size === SpinnerSize.Small || size <= 28;
  var DisplayComponent = isSmall ? _layout.Row : _layout.Col;
  var gridGap = isSmall ? 8 : 16;
  var dimension = typeof size === 'number' ? size : getSpinnerDimension(size); // This should be refactored before the major version release by removing ProgressArcPath.
  // https://sim.amazon.com/issues/StencilDevelopment-1191

  var path = typeof size === 'number' ? (0, _ProgressArc.calculateProgressArcPath)({
    progress: progress,
    size: size,
    start: start,
    strokeWidth: strokeWidth,
    color: color,
    opacity: opacity
  }) : (0, _utils2.calculateSpinnerPath)({
    size: size,
    color: color
  });
  return (0, _core.jsx)(_liveAnnouncer.LiveRegion, {
    role: _liveAnnouncer.LiveRegionRole.Status,
    "aria-live": "polite"
  }, (0, _core.jsx)(DisplayComponent, {
    alignItems: "center",
    gridGap: gridGap,
    margin: margin
  }, (0, _core.jsx)("svg", (0, _extends2.default)({
    role: "img",
    width: dimension,
    height: dimension,
    "aria-hidden": showText,
    xmlns: "http://www.w3.org/2000/svg"
  }, outerProps), !showText && loadingText && (0, _core.jsx)("title", null, loadingText), path), showText && loadingText && (0, _core.jsx)(_text.Text, {
    fontSize: "T100",
    color: textColor,
    textAlign: "center"
  }, loadingText)));
};

var SpinnerBase = (
/*#__PURE__*/
0, _styledBase.default)(SpinnerComponent, {
  target: "ekdk61i0"
})(function (_ref2) {
  var speed = _ref2.speed;

  if (speed === 0) {
    return {
      animation: 'none'
    };
  }

  var time = speed ? 1 / speed : 1;
  return {
    animation: "".concat(time, "s linear 0s infinite normal none running ").concat(rotate)
  };
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
SpinnerBase.defaultProps = {
  start: 0,
  progress: 0.66666,
  opacity: 0.5,
  strokeWidth: 4,
  margin: 0,
  loadingText: 'Loading...',
  showText: false,
  textColor: 'neutral70',
  speed: 1.25,
  size: SpinnerSize.Small,
  color: 'primary70'
};
var SpinnerBaseWithDocs = (0, _stencilReactDesc.describe)(SpinnerBase).description('Animated loading indicator.');
SpinnerBaseWithDocs.propTypes = {
  loadingText: _stencilReactDesc.PropTypes.string.description('Text that describes the loading.'),
  showText: _stencilReactDesc.PropTypes.bool.description("Determines whether to show the loading text. When false, the text is instead used as the 'title' attribute for the image. It is strongly encouraged to visually show the loading text."),
  textColor: _stencilReactDesc.PropTypes.string.description('Color of the displayed text.'),
  size: _stencilReactDesc.PropTypes.oneOfType([_stencilReactDesc.PropTypes.number, _stencilReactDesc.PropTypes.string]).description('Diameter of the arc, either in pixels or as a named size.'),
  start: _stencilReactDesc.PropTypes.number.description('Angle from the top of the arc to start the colored segment, in degrees.'),
  progress: _stencilReactDesc.PropTypes.number.description('Amount of the arc to fill with the colored segment, as a value between 0 and 1.'),
  color: _stencilReactDesc.PropTypes.string.description('Color to use for the colored segment.'),
  opacity: _stencilReactDesc.PropTypes.number.description('Opacity of the unfilled section of the arc, as a value between 0 and 1.'),
  strokeWidth: _stencilReactDesc.PropTypes.number.description('Width of the arc stroke, in pixels.'),
  margin: _stencilReactDesc.PropTypes.oneOfType([_stencilReactDesc.PropTypes.string, _stencilReactDesc.PropTypes.number]).description('Margin around the entire element.'),
  speed: _stencilReactDesc.PropTypes.number.description('Defines speed of the rotation.')
};
var Spinner = (0, _utils.withTestAttributes)({
  component: 'StencilReactSpinner'
})(SpinnerBaseWithDocs);
Spinner.displayName = 'Spinner';
var _default = Spinner;
exports.default = _default;